export default class destinationSearch {
  constructor(selector) {
    this.forms = document.querySelectorAll(selector);
    if (this.forms.length === 0) {
      throw new Error(`Form(s) with selector ${selector} not found`);
    }

    this.init(this.forms);
  }

  async init(forms) {
    this.destinations = await this.initDestinations();
    forms.forEach((form) => {
      this.initForm(form);
    });
  }

  initForm(form) {
    const input = form.querySelector("input");
    const resultsUI = form.querySelector(".js-results");

    form.addEventListener("submit", (event) => this.handleSubmit(event, input));
    input.addEventListener("input", () => this.handleInput(input, resultsUI));
  }

  async initDestinations() {
    const url = `/wp-json/wp/v2/destination`;
    try {
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(
          `Failed to fetch destinations: ${response.status} - ${response.statusText}`
        );
      }
      const json = await response.json();
      return json.map((item) => item.title.rendered.toLowerCase());
    } catch (error) {
      console.error(`Error fetching data from ${url}:`, error);
      return [];
    }
  }

  handleSubmit(event, input) {
    event.preventDefault();
    console.log(event);
  }

  handleInput(input, resultsUI) {
    const query = input.value.toLowerCase();
    let resultsArr = [];

    if (query.length > 0) {
      resultsArr = this.destinations.filter((destination) =>
        destination.startsWith(query)
      );
    }

    this.updateResultsUI(resultsArr, resultsUI);
  }

  updateResultsUI(results, resultsUI) {
    const ul = resultsUI.querySelector("ul");
    ul.innerHTML = "";

    if (results.length === 0) {
      resultsUI.classList.add("hidden"); // Hide the UI if there's nothing to show.
      return;
    }

    // Make sure the UI is visible since we have new data to display.
    resultsUI.classList.remove("hidden");

    results.forEach((item) => {
      const li = document.createElement("li");
      const a = document.createElement("a");
      a.classList.add("hover:text-blue");

      a.textContent =
        item.charAt(0).toUpperCase() + item.slice(1).toLowerCase();
      a.href = `/destination/${item}`;

      li.appendChild(a);
      ul.appendChild(li);
    });

    resultsUI.appendChild(ul); // Integrate the constructed list into the UI to render the results.
  }
}
